import { render, staticRenderFns } from "./renew_remind.vue?vue&type=template&id=a563c2d4&scoped=true"
import script from "./renew_remind.vue?vue&type=script&lang=js"
export * from "./renew_remind.vue?vue&type=script&lang=js"
import style0 from "./renew_remind.vue?vue&type=style&index=0&id=a563c2d4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a563c2d4",
  null
  
)

export default component.exports